<template>
  <div class="vehicle-animation">
    <div class="exhaust-container">
      <div class="exhaust-puff puff-1"></div>
      <div class="exhaust-puff puff-2"></div>
      <div class="exhaust-puff puff-3"></div>
    </div>
    <div class="vehicle-icon">
      <svg viewBox="0 0 68 32" width="51" height="24">
        <!-- main body -->
        <rect x="4" y="14" width="58" height="10" rx="2" fill="#FFD500"/>
        <!-- hood (extended) -->
        <path d="M 50 14 L 62 14 L 62 20 L 50 20 Z" fill="#FFD500"/>
        <!-- trunk -->
        <path d="M 4 14 L 12 14 L 12 20 L 4 20 Z" fill="#FFD500"/>
        <!-- cabin/roof -->
        <path d="M 14 14 Q 16 7, 22 7 L 44 7 Q 50 7, 50 14" fill="#FFD500"/>
        <!-- taxi sign on roof -->
        <rect x="28" y="4" width="10" height="4" rx="1" fill="#fff"/>
        <text x="33" y="7" font-size="3" fill="#333" text-anchor="middle" font-weight="bold">TAXI</text>
        <!-- rear window -->
        <path d="M 14 14 Q 15 9, 20 8 L 20 14 Z" fill="#87ceeb"/>
        <!-- passenger windows -->
        <rect x="22" y="8" width="8" height="6" rx="1" fill="#87ceeb"/>
        <rect x="32" y="8" width="8" height="6" rx="1" fill="#87ceeb"/>
        <!-- front windshield (angled toward front/right) -->
        <path d="M 40 14 L 46 8 L 50 14 Z" fill="#87ceeb"/>
        <!-- checker stripe -->
        <rect x="4" y="19" width="4" height="3" fill="#333"/>
        <rect x="12" y="19" width="4" height="3" fill="#333"/>
        <rect x="20" y="19" width="4" height="3" fill="#333"/>
        <rect x="28" y="19" width="4" height="3" fill="#333"/>
        <rect x="36" y="19" width="4" height="3" fill="#333"/>
        <rect x="44" y="19" width="4" height="3" fill="#333"/>
        <rect x="52" y="19" width="4" height="3" fill="#333"/>
        <!-- wheels -->
        <circle cx="14" cy="24" r="5" fill="#333"/>
        <circle cx="14" cy="24" r="2" fill="#666"/>
        <circle cx="54" cy="24" r="5" fill="#333"/>
        <circle cx="54" cy="24" r="2" fill="#666"/>
        <!-- headlight -->
        <rect x="60" y="16" width="2" height="3" rx="1" fill="#ffdd00"/>
        <!-- taillight -->
        <rect x="4" y="16" width="2" height="3" rx="1" fill="#cc0000"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaxiAnimation'
}
</script>

<style scoped>
.vehicle-animation {
  display: flex;
  align-items: center;
}

.exhaust-container {
  position: relative;
  width: 0px;
  height: 24px;
  margin-left: 20px;
}

.exhaust-puff {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #999;
  border-radius: 50%;
  opacity: 0;
  right: 0;
}

.puff-1 {
  bottom: 4px;
  animation: puff-float 1.2s ease-out infinite;
}

.puff-2 {
  bottom: 8px;
  animation: puff-float 1.2s ease-out infinite 0.4s;
}

.puff-3 {
  bottom: 12px;
  animation: puff-float 1.2s ease-out infinite 0.8s;
}

.vehicle-icon {
  animation: vehicle-bounce 0.5s ease-in-out infinite;
}

@keyframes vehicle-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

@keyframes puff-float {
  0% {
    opacity: 0.7;
    transform: translateX(0) scale(0.5);
  }
  100% {
    opacity: 0;
    transform: translateX(-15px) scale(1.2);
  }
}
</style>
